export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png'] as const;

export const MAX_FILES = 4 as const;

export const ERROR_MESSAGES = {
  MAX_FILES: 'RECUERDA: Solo puedes seleccionar un máximo de 4 archivos',
  UNSUPPORTED_FORMAT:
    'RECUERDA: Solo puedes pegar imágenes en formato JPG o PNG',
} as const;
